import alt from 'framework/alt';

class TermActions {
  constructor() {
    this.generateActions(
      'fetchSucceeded',
      'fetchFailed',
      'setLegalData',
    );
  }
}

export default alt.createActions(TermActions);
